let HTTP_URL = 'https://api.thecover.cn'
let ACTIVITY_URL = process.env.NODE_ENV === 'development' ? '/api' : 'https://actapi.thepage.cn'
let WAP_URL = 'https://m.thecover.cn'
let WEB_URL = 'https://www.thecover.cn'

// if (true) {
//     HTTP_URL = 'https://cover-api.test.thecover.cn'
//     ACTIVITY_URL = 'https://demo-actapi.fm-dev.thecover.cn'
//     WAP_URL = 'https://cover-m.test.thecover.cn'
//     WEB_URL = 'https://cover-www.test.thecover.cn'
// }

export default {
    HTTP_URL, // 封面新闻接口地址 
    ACTIVITY_URL, // 活动接口地址
    TRACK_URL: 'https://yun.thecover.cn/fmio/web/receive', // 数据部埋点接口地址
    WAP_URL, // wap地址
    WEB_URL, // web地址
    UNIVERSALLINK: 'https://wapcdn.thecover.cn/UniversalLinks/index.html', // UniversalLink地址
    WEXIN_APP_DOWNLOAD_ADDRESS: "http://a.app.qq.com/o/simple.jsp?pkgname=cn.thecover.www.covermedia", // 微信应用宝地址
	APP_SCHEME_URL: "cover://cn.thecover.www", // scheme地址
    ApiToken: sessionStorage.getItem('TOKEN'),
    Api_sign_root: '12345678',
    wx_appid: 'wx1294924fd43f1119',
    timestamp: new Date().getTime(), // 当前时间戳
    DOWNLOAD_ADDRESS: 'https://api.thecover.cn/download.js'
}
